export default {
  HOME_PAGE: 'HOME_PAGE',
};



// WEBPACK FOOTER //
// ./app/constants/NavPages.js